/** When computing the approx package size, how many pins to use as margin in the X dir */
export const packageSizeMarginPinsX = 1;
/** When computing the approx package size, how many pins to use as margin in the Y dir */
export const packageSizeMarginPinsY = 1;
// 3D Model
export const greenHeight = 0.0001;
export const pinMarkerSize = 0.0004;
export const pinMarkerOffset = (packageSizeX, packageSizeY) => (Math.log10(10 + Math.min(packageSizeX, packageSizeY) * 5000) - 1) / 500;
export const pinMarkerOffsetZ = 0.000001;
export const pinMarkerBevel = 0.0001;
//# sourceMappingURL=gridArrayConstants.js.map